import { render, staticRenderFns } from "./ListIndustry.vue?vue&type=template&id=00988d76"
import script from "./ListIndustry.vue?vue&type=script&lang=js"
export * from "./ListIndustry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListIndustry.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00988d76')) {
      api.createRecord('00988d76', component.options)
    } else {
      api.reload('00988d76', component.options)
    }
    module.hot.accept("./ListIndustry.vue?vue&type=template&id=00988d76", function () {
      api.rerender('00988d76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/views/ListIndustry.vue"
export default component.exports